import { SET_FILTERS, SET_IS_FILTERED, SET_TRAVELS } from '../../types';

const INITIAL_FILTERS = {
  passenger: '',
  driver: '',
  paymentMethod: '',
  paymentStatus: '',
  initialDate: '',
  finalDate: '',
};

const INITIAL_STATE = { travels: [], isFiltered: false, filters: INITIAL_FILTERS };

export default function travels(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_TRAVELS:
      return { ...state, travels: action.travels };
    case SET_IS_FILTERED:
      return { ...state, isFiltered: action.isFiltered };
    case SET_FILTERS:
      return { ...state, filters: action.filters };
    default:
      return state;
  }
}
